// Created by hejikun on 2017/10/25 0025.
let state = {
  clinic_hospital_list: [],
  clinic_hospital_detail: [],
  clinic_department_list: [],
  clinic_guidan_sex: [],
  clinic_guidan: [],
  clinic_doctor_list: [],
  clinic_res_list: [],
  clinic_hasMore: false
}
let host = ''
if (window.location.hostname.indexOf('appv3.ynhdkc.com') > -1) {
  host = 'https://newdytapi.ynhdkc.com'
} else {
  host = 'https://newdytapi.ynhdkc.com'
}
const actions = {
  // 获取列表
  loadClinicList({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'clinic_hospital_list': // 获取医院列表
        url = `cli/clinic?type=1`
        break
      case 'clinic_department_list': // 获取医院列表
        url = `${host}/index/hospital/871006/depart`
        break
      case 'clinic_doctor_list': // 获取医生列表
        url = `Intelligent/Intellectsymptom/index/act/sym?hosid=${args.hos_id}&depid=${args.dep_id}&symid=${args.sys_id}`
        break
      case 'clinic_res_list': // 获取医生列表
        url = `${host}/index/doctor?hos_code=${args.hos_id}&dep_id=${args.dep_id}&doc_class_id=${args.doc_class_id}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        res.data.code === 1
          ? (() => {
              commit({
                type: 'set_clinic_list',
                dataType: args.type,
                data: res.data.data,
                page: args.page
              })
            })()
          : commit({
              type: 'set_clinic_list',
              dataType: args.type,
              data: [],
              page: args.page
            })
        return Promise.resolve(res.data.data)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  },
  // 获取详情
  loadCliDetail({ commit }, args) {
    let url = ''
    switch (args.type) {
      case 'clinic_hospital_detail': // 获取医院详情
        url = `/cli/clinic/${args.id}`
        break
      case 'clinic_guidan_sex': // 年龄
        url = `/Intelligent/Dictionary/index/act`
        break
      case 'clinic_guidan': // 症状
        url = `Intelligent/Intellectsymptom/index/act/all?age=${args.age}&sex=${args.sex}&hosid=${args.hos_code}`
        break
      default:
        return Promise.reject(new Error('请求参数异常'))
    }
    window.axiosBaseApi
      .get(url)
      .then((res) => {
        if (res.data.code === 1) {
          commit({
            type: 'set_detail',
            dataType: args.type,
            data: res.data.data
          })
          return Promise.resolve(res.data.data)
        } else {
          commit({
            type: 'set_detail',
            dataType: args.type,
            data: {}
          })
          return Promise.resolve([])
        }
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
}

const getters = {}

const mutations = {
  // 设置列表
  set_clinic_list(state, args) {
    args.data.length < 10 ? (state.ask_hasMore = false) : (state.clinic_hasMore = true)
    if (args.page === 1) {
      if (args.data.length === 0) {
        state[args.dataType] = []
      } else {
        state[args.dataType] = args.data
      }
    } else {
      if (args.data.length !== 0) {
        args.data.forEach((item) => {
          state[args.dataType].push(item)
        })
      }
    }
  },
  // 设置详情
  set_detail(state, args) {
    state[args.dataType] = args.data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
